import * as v from 'valibot';
import { Tag } from '~/api';
import { IdSchema } from './common';
import { t } from 'i18next';

export const TagTypeSchema = v.picklist<Tag['type'][]>([ 'campaign-visual', 'pos', 'question' ]);

export const TagSchema = v.object({
	id: IdSchema,
	name: v.string(),
	type: TagTypeSchema,
	color: v.nullable(v.string()),
});

export const TagRequestSchema = v.object({
	name: v.pipe(v.string(), v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.'))),
	tagCategoryId: v.nullable(IdSchema),
	type: TagTypeSchema,
	color: v.nullable(v.string()),
});
